import React from 'react'
import PropTypes from 'prop-types'

const Header = (props) => (
    <header id="header" style={props.timeout ? { display: 'none' } : {}}>
        <div className="logo">
            <span className="icon fa-heartbeat"></span>
        </div>
        <div className="content">
            <div className="inner">
                <h1>Codepye</h1>
                <p>
                    New to software development?
                    Having a hard time getting started with programming?
                    Looking for some easy way to learning coding?
                    Codepy is a way to go!
                    Coming soon...
                </p>
            </div>
        </div>
        <nav>
            <ul>
                {/* <li><a href="javascript:;" onClick={() => { props.onOpenArticle('intro') }}>Intro</a></li>
                <li><a href="javascript:;" onClick={() => { props.onOpenArticle('work') }}>Work</a></li>
                <li><a href="javascript:;" onClick={() => { props.onOpenArticle('about') }}>About</a></li> */}

                {/* <li><a href="javascript:;" onClick={() => { props.onOpenArticle('contact') }}>Contact</a></li> */}
                <li><a href="mailto:codepye&#64;gmail.com?subject=Re:%20codepye.com">Contact</a></li>
            </ul>
        </nav>
    </header>
)

Header.propTypes = {
    onOpenArticle: PropTypes.func,
    timeout: PropTypes.bool
}

export default Header
